import { AbortError } from '../AbortError';
import { isNativeError } from './isNativeError';

// Проверяет, что ошибка является инстансом нативного или структурированного AbortError
export function isAbortError(err: unknown): err is Error {
    return err instanceof AbortError || (isNativeError(err) && err.name === 'AbortError');
}
